import {
  createExploToken,
  thoughtspotTokenOrganization,
  thoughtspotLiveboardsOrganization
} from '@goldcast/api/backend';

import { parseIntegrationApiError } from '@/studio/orgIntegration/store/utils';
import { showErrorNotification } from '@/utils/utils.js';

const actions = {
  async fetchUserGroupToken({ commit }, eventID: string) {
    commit('setLoadingState', true);
    try {
      const res = await createExploToken({
        id: eventID
      });
      commit('setUserGroupToken', res.token);
      commit('setExploError', false);
    } catch {
      commit('setExploError', true);
      commit('setUserGroupToken', '');
    } finally {
      commit('setLoadingState', false);
    }
  },
  fetchThoughtSpotToken(context) {
    return new Promise((resolve, reject) => {
      const orgID = context.rootGetters['org/getCurrentOrgId'];
      thoughtspotTokenOrganization({
        id: orgID
      })
        .then(({ response, error }) => {
          if (error) {
            throw new Error(JSON.stringify(error));
          }
          resolve((response as Record<string, any>).token);
        })
        .catch(error => {
          const parsedError = parseIntegrationApiError(error);
          showErrorNotification(parsedError.message, 10000);
          reject();
        });
    });
  },
  async fetchLiveboards(context) {
    try {
      const orgID = context.rootGetters['org/getCurrentOrgId'];
      const res = await thoughtspotLiveboardsOrganization({
        id: orgID
      });
      return res;
    } catch (error) {
      const parsedError = parseIntegrationApiError(error);
      showErrorNotification(parsedError.message, 3000);
      return parsedError;
    }
  }
};

export default actions;
